
import './PartnerCard.css'

interface PartnerCardProps {
  name: string
  type: 'human' | 'agent'
  compatibility: number
  bio: string
  skills: string[]
  matchReasons: string[]
  onConnect?: () => void
}

export default function PartnerCard({ 
  name, 
  type, 
  compatibility, 
  bio, 
  skills, 
  matchReasons,
  onConnect 
}: PartnerCardProps) {
  return (
    <div className="partner-card-component">
      <div className="partner-card-header">
        <div className="partner-identity">
          <span className="partner-icon">{type === 'agent' ? '🤖' : '👤'}</span>
          <h3 className="partner-name">{name}</h3>
        </div>
        <div className="compatibility-badge">
          <span className="compat-score">{compatibility}%</span>
          <span className="compat-label">Match</span>
        </div>
      </div>
      
      <p className="partner-bio">{bio}</p>
      
      <div className="partner-skills">
        {skills.map(skill => (
          <span key={skill} className="skill-chip">{skill}</span>
        ))}
      </div>
      
      <div className="match-reasons-box">
        <h4>Why you match:</h4>
        <ul>
          {matchReasons.map((reason, i) => (
            <li key={i}>{reason}</li>
          ))}
        </ul>
      </div>

      {onConnect && (
        <button className="connect-button" onClick={onConnect}>
          Request Connection →
        </button>
      )}
    </div>
  )
}
